import axios from 'axios';

import { CHATBOT_AXIOS_CONFIG, DEFAULT_AXIOS_CONFIG } from './axiosConfig';

const instance = axios.create(DEFAULT_AXIOS_CONFIG);

export const chatbotStreamInstance = axios.create(CHATBOT_AXIOS_CONFIG);

export default instance;
